var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-4 leyend-container"},[_c('p',{staticClass:"text"},[_c('i',{staticClass:"fa fa-user"}),_vm._v(" Estudiante: Es requerido añadir un estudiante a la SAEE-12b. ")]),_c('p',{staticClass:"text mb-0"},[_c('i',{staticClass:"fa fa-users"}),_vm._v(" Grupo: Es requerido añadir más de un estudiante a la SAEE-12b. ")])])
}]

export { render, staticRenderFns }